import { useState } from 'react';
import { Accordion, AccordionProps } from './single';

export interface AccordionItem {
  id: string;
  summary: AccordionProps['summary'];
  content: AccordionProps['content'];
  summaryProps?: AccordionProps['summaryProps'];
  contentProps?: AccordionProps['contentProps'];
  className?: string;
}

interface AccordionGroupProps {
  items: AccordionItem[];
  allowMultiple?: boolean;
  defaultOpenIds?: string[];
  className?: string;
}

export const AccordionGroup: React.FC<AccordionGroupProps> = ({
  items,
  allowMultiple = false,
  defaultOpenIds = [],
  className,
}) => {
  const [openIds, setOpenIds] = useState<string[]>(defaultOpenIds);

  const handleToggle = (id: string) => {
    setOpenIds((prev) => {
      if (allowMultiple) {
        return prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id];
      }
      return prev.includes(id) ? [] : [id];
    });
  };

  return (
    <div className={className}>
      {items.map((item) => (
        <Accordion
          key={item.id}
          summary={item.summary}
          content={item.content}
          summaryProps={item.summaryProps}
          contentProps={item.contentProps}
          className={item.className}
          open={openIds.includes(item.id)}
          onClick={() => handleToggle(item.id)}
        />
      ))}
    </div>
  );
};
